module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/~/axios/index.js
// module id = 1356
// module chunks = 0